var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CountryDescriptorArray, IrelandCountryDescriptor, UKCountryDescriptor } from "../constants/countries.constants";
import { uniq } from "./ramdaEquivalents.utils";
import { formatSearchString } from "./string.utils";
import { isArray } from "./typeChecks.utils";
export var createDialCodeRegex = function (code) { return new RegExp("^\\+" + code.replace('-', '\\-') + "(.*)"); };
export var allDialCodes = uniq(__spreadArray([
    IrelandCountryDescriptor.dialCode,
    UKCountryDescriptor.dialCode
], CountryDescriptorArray.map(function (d) { return d.dialCode; }).filter(function (d) { return !!d; }), true).flat());
Reflect.set(window, 'dialCodes', allDialCodes);
export var countriesByDialCodes = allDialCodes.map(function (code) {
    var countries = CountryDescriptorArray.filter(function (country) { return country.dialCode ? (isArray(country.dialCode) ? country.dialCode.includes(code) : country.dialCode === code) : false; });
    return {
        dialCode: code,
        regex: createDialCodeRegex(code),
        countries: countries,
        searchString: formatSearchString(countries.map(function (country) { return [country.name, country.cca2, country.dialCode ? JSON.stringify(country.dialCode) : ''].join('_'); }).join('__')),
    };
});
Reflect.set(window, 'countriesByDialCodes', countriesByDialCodes);
export var countriesSortedByDialCodeLength = __spreadArray([], countriesByDialCodes, true).sort(function (a, b) { return b.dialCode.length - a.dialCode.length; });
export var getCountryCodeFromString = function (tel) {
    var _a, _b;
    if (!tel)
        return null;
    if (tel[0] !== '+') {
        if (tel.length === 12 || tel.length === 13) {
            if (tel.match(/^353/))
                return 'IE';
            if (tel.match(/^44/))
                return 'GB';
        }
    }
    for (var _i = 0, countriesSortedByDialCodeLength_1 = countriesSortedByDialCodeLength; _i < countriesSortedByDialCodeLength_1.length; _i++) {
        var country = countriesSortedByDialCodeLength_1[_i];
        if (tel.match(country.regex))
            return (_b = (_a = country.countries[0]) === null || _a === void 0 ? void 0 : _a.cca2) !== null && _b !== void 0 ? _b : '';
    }
    return null;
};
